import {Map, List, fromJS } from 'immutable'

const getFrom = (state) => state.getIn(['automessage', 'items'], List());
const getById = (state, autoId) => state.getIn(['automessage', 'items', autoId], Map());


const getTitle = (automessage) => automessage.getIn(['message', 'message', 'title'], "")
const getMessage = (automessage) => automessage.getIn(['message', 'message', 'message'], "")
const getPriority = (automessage) => automessage.getIn(['message', 'message', 'priority'], 0)
const getFrequency = (automessage) => automessage.getIn(['message', 'message', 'frequency'], 'always')
const getMessageDuration = (automessage) => automessage.getIn(['message', 'message', 'message_duration'], 10)

const getVisitor = (automessage) => automessage.getIn(['message', 'visitor'], 'all')
const getUrl= (automessage) => automessage.getIn(['message', 'url'], 'http')
const getTime= (automessage) => automessage.getIn(['message', 'time'], fromJS([{time_before: [8,0], time_after: [17,0]}]))

const getWeekDays= (automessage) => automessage.getIn(['message', 'days_of_the_week'], fromJS([0,1,2,3,4]))

export default {
    getFrom,
    getById, getFrequency,
    getTitle, getMessage, getPriority, getUrl, getTime, getVisitor, getWeekDays, getMessageDuration
}



// WEBPACK FOOTER //
// ./src/model/AutoMessage/selector.js